import globalState from '../state';
import CONSTANTS from '../constants';
import { formataDataWebMethodParaString, formataCentavoZerado } from '../modules/util';


let initialStateSol = globalState.solicitacao;

let dadosInteressado = (state = initialStateSol.dadosInteressado, action) => {
    var payload = action.payload;
    var acoes = {
        [CONSTANTS.NEXT_STEP]: () => {
            return { ...state, campoErros: {} };
        },
        [CONSTANTS.BACK_STEP]: () => {
            return { ...state, campoErros: {} };
        },
        [CONSTANTS.CHANGE_CAMPO_GENERICO_INTERESSADO]: () => {
            var obj = {
                [action.payload.campoState]: action.payload.valor
            };
            if (payload.campoState === "pesCPF") {
                obj.cpfOK = false;
            }
            if (payload.campoState === "possuiAlgumaDeficiencia" && payload.valor === "N") {
                obj.tdfCodigo = "";
            }
            if (payload.campoState === "solEnem" && payload.valor !== "S") {
                obj.solAnoEnem = "";
                obj.solPontEnem = "";
            }
            if (payload.campoState === "solCursoSup" && payload.valor !== "S") {
                obj.solNomeCursoSup = "";
            }
            if (payload.campoState === "pesRendaBruta" || payload.campoState === "conjugePesRendaBruta") {
                obj[payload.campoState] = formataCentavoZerado(obj[payload.campoState]);
            }
            if (payload.campoState === "pesRendaBruta" || payload.campoState === "conjugePesRendaBruta") {
                obj[payload.campoState] = formataCentavoZerado(obj[payload.campoState]);
            }
            if (payload.campoState === 'solPontEnem') {
                obj[payload.campoState] = obj[payload.campoState] && obj[payload.campoState].replace(/[^\d]/gim, "");
            }

            return { ...state, ...obj };
        },
        [CONSTANTS.GET_DADOS_INTERESSADO_CPF.LOADING]: () => {
            return { ...state, carregandoPessoaCPF: true };
        },
        [CONSTANTS.GET_DADOS_INTERESSADO_CPF.SUCCESS]: () => {

            var dadosPessoa = payload.dadosPessoa;
            var permissaoAlterar = payload.permissaoAlterar;
            var pessoa = {
                pesSexo: "",
                pesNro: "",
                nacCodigo: "",
                pesNome: "",
                emlEmail: "",
                pesDtNasc: "",
                pesRG: "",
                pesEstExp: "",
                pesOrgExp: "",
                pesTelefone: "",
                pesCelular: "",
                pesBairro: "",
                tdfCodigo: 0,
                pesCEP: "",
                pesRua: "",
                //  listCidades: [],
                locCodigo: "",
                uf: "",
                pesEstCiv: "",
                possuiAlgumaDeficiencia: "N"
            };

            if (dadosPessoa) {
                pessoa = {
                    nacCodigo: dadosPessoa.NacCodigo,
                    pesSexo: dadosPessoa.PesSexo,
                    pesNro: dadosPessoa.PesNro,
                    pesNome: dadosPessoa.PesNome.trim(),
                    emlEmail: dadosPessoa.Email,
                    pesDtNasc: formataDataWebMethodParaString(dadosPessoa.PesDatnas),
                    pesRG: dadosPessoa.PesRg,
                    pesEstExp: dadosPessoa.PesEstExp,
                    pesOrgExp: dadosPessoa.PesOrgExp,
                    pesTelefone: dadosPessoa.PesTelefone,
                    pesCelular: dadosPessoa.PesCelular,
                    pesBairro: dadosPessoa.PesBairro,
                    tdfCodigo: 0, //deficiencia                
                    pesCEP: dadosPessoa.PesCep,
                    pesRua: dadosPessoa.PesRua,
                    //  listCidades: [],
                    locCodigo: dadosPessoa.LocCodigo || "",
                    uf: dadosPessoa.LocUf,
                    pesEstCiv: dadosPessoa.PesEstCiv,
                    possuiAlgumaDeficiencia: "N"
                }

            }
            return {
                ...state,
                ...pessoa,
                cpfOK: true,
                carregandoPessoaCPF: false,
                permissaoAlterar: permissaoAlterar
            };
        },
        [CONSTANTS.GET_DADOS_INTERESSADO_CONJUGE_CPF.SUCCESS]: () => {
            var dadosPessoa = payload.dadosPessoa;
            var permissaoAlterar = payload.permissaoAlterar;
            var pessoa = {
                conjugePesNro: "",
                conjugePesNome: "",
                conjugePesDtNasc: "",
                conjugePesRG: "",
                conjugePesEstExp: "",
                conjugePesOrgExp: "",
                conjugePesTelefone: "",
                conjugePesCelular: "",
                conjugePesSexo: "",
                conjugeNacCodigo: ""
            };

            if (dadosPessoa) {
                pessoa = {
                    conjugeNacCodigo: dadosPessoa.NacCodigo,
                    conjugePesSexo: dadosPessoa.PesSexo,
                    conjugePesNro: dadosPessoa.PesNro,
                    conjugePesNome: dadosPessoa.PesNome.trim(),
                    conjugePesDtNasc: formataDataWebMethodParaString(dadosPessoa.PesDatnas),
                    conjugePesRG: dadosPessoa.PesRg,
                    conjugePesEstExp: dadosPessoa.PesEstExp,
                    conjugePesOrgExp: dadosPessoa.PesOrgExp,
                    conjugePesTelefone: dadosPessoa.PesTelefone,
                    conjugePesCelular: dadosPessoa.PesCelular
                }

            }
            return {
                ...state,
                ...pessoa,
                conjuge_cpfOK: true,
                conjuge_carregandoPessoaCPF: false,
                conjugePermissaoAlterar: permissaoAlterar
            };
        },
        [CONSTANTS.CARREGAR_LIST_CIDADES.LOADING]: () => {
            return {
                ...state,
                carregandoCidades: true
            };
        },
        [CONSTANTS.CARREGAR_LIST_CIDADES.SUCCESS]: () => {
            return {
                ...state,
                carregandoCidades: false,
                listCidades: payload
            };
        },
        [CONSTANTS.CARREGAR_LIST_CIDADES.ERROR]: () => {
            return {
                ...state,
                carregandoCidades: false
            };
        },
        [CONSTANTS.GET_DADOS_INTERESSADO_CPF.ERROR]: () => {

            return { ...state, erro: action.payload.message || "ERROR", carregandoPessoaCPF: false };
        },
        [CONSTANTS.EDITAR_CPF]: () => {

            return { ...state, cpfOK: false };
        },
        [CONSTANTS.CONJUGE_EDITAR_CPF]: () => {

            return { ...state, conjuge_cpfOK: false };
        },
        [CONSTANTS.CARREGAR_LIST_DEFICIENCIA.LOADING]: () => {
            return { ...state, carregandoPessoaCPF: true };
        },
        [CONSTANTS.CARREGAR_LIST_DEFICIENCIA.SUCCESS]: () => {
            return { ...state, listDeficiencias: action.payload, carregandoPessoaCPF: false };
        },
        [CONSTANTS.CARREGAR_LIST_DEFICIENCIA.ERROR]: () => {
            return { ...state, erro: action.payload.message || "ERROR", carregandoPessoaCPF: false };
        },
        [CONSTANTS.POSSUI_ALGUMA_DEFICIENCIA]: () => {
            return { ...state, possuiAlgumaDeficiencia: payload };
        },
        [CONSTANTS.CONSULTA_CEP.LOADING]: () => { return { ...state, carregandoCEP: true }; },
        [CONSTANTS.CONSULTA_CEP.ERROR]: () => { return { ...state, carregandoCEP: false }; },
        [CONSTANTS.CONSULTA_CEP.SUCCESS]: () => {
            var cep = {
                pesBairro: payload.bairro.toUpperCase(),
                pesRua: payload.rua.toUpperCase(),
                uf: payload.uf.toUpperCase(),
                cidadeCEP: payload.cidade.toUpperCase()
            };
            if (payload.locCodigo) {
                cep.locCodigo = payload.locCodigo;

            }
            if (payload.listCidades) {
                cep.listCidades = payload.listCidades;
            }
            return { ...state, ...cep, carregandoCEP: false };
        },
        [CONSTANTS.ERROR_INTERESSADO]: () => {
            return { ...state, campoErros: { ...payload } };
        }
    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;
};


export default dadosInteressado;


// WEBPACK FOOTER //
// ./src/reducers/dados-interessado.js